import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'ngx-avatars';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-user-logo',
  standalone: true,
  imports: [CommonModule, AvatarModule],
  template: `
    <div class="container">
      <div class="header-avatar-container">
        <ngx-avatars class="header-avatar" [name]="name" [src]="thumbnailPhoto" [round]="true"></ngx-avatars>
      </div>
      <span *ngIf="1 && !isSmall" class="mat-subtitle-2">&nbsp;&nbsp;{{ name }}</span>
    </div>
  `,
  styles: [
    `
      :host {
        .container {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding-right: 10px;
        }

        /* .header-avatar-container {
          height: 62px;
          width: 62px;
          padding-right: 24px;
        } */

        .header-avatar {
          cursor: pointer;
        }
        //flex: 1 1 auto;
      }
    `,
  ],
})
export class UserLogoComponent {
  @Input() isSmall: boolean;
  @Input({ required: true }) name: string;
  @Input() thumbnailPhoto: string;
}
